<template>
  <div
    class="roaming-rates-country p-8 w-11/12 sm:w-full md:w-5/6 lg:w-7/12 xl:w-7/12"
  >
    <div class="mx-auto">
      <h2 class="text-2xl font-bold mb-6">{{ country.displayName }}</h2>

      <!-- Tariff Table -->
      <table class="w-full mb-8">
        <thead>
          <tr v-if="!country.displayName" class="bg-primary text-white">
            <th colspan="3" class="p-4 text-left h-[50px]">
              Roaming rates on ships, flights & satellite phones
            </th>
          </tr>
          <tr class="bg-primary text-white h-[75px]">
            <th class="p-4 text-left">
              {{ country.displayName || "Ships/Satellite" }}
            </th>
            <th class="p-4 text-left">Make/Send</th>
            <th class="p-4 text-left">Receive</th>
          </tr>
        </thead>
        <tbody>
          <tr class="bg-white bg-opacity-20">
            <td class="p-4">Calls (incl voicemail)</td>
            <td class="p-4">
              {{ capitalizeFirst(country.tariff?.rateMakeCalls) }}
            </td>
            <td>{{ capitalizeFirst(country.tariff?.rateReceiveCalls) }}</td>
          </tr>
          <tr class="bg-primary bg-opacity-20 font-bold text-xl">
            <td class="">SMS</td>
            <td>{{ capitalizeFirst(country.tariff?.rateSendSMS) }}</td>
            <td>{{ capitalizeFirst(country.tariff?.rateReceiveSMS) }}</td>
          </tr>
          <tr class="bg-white bg-opacity-20 font-bold text-xl">
            <td class="p-4">MMS to AU number</td>
            <td>
              {{
                capitalizeFirst(country.tariff?.rateReceiveMMSAu) ||
                "Not available"
              }}
            </td>
            <td>
              {{
                capitalizeFirst(country.tariff?.rateSendMMSAu) ||
                "Not available"
              }}
            </td>
          </tr>
          <tr class="bg-primary bg-opacity-20 font-bold text-xl">
            <td class="p-4">MMS to non-AU number</td>
            <td>
              {{
                capitalizeFirst(country.tariff?.rateSendMMSNonAu) ||
                "Not available"
              }}
            </td>
            <td>
              {{
                capitalizeFirst(country.tariff?.rateReceiveMMSNonAU) ||
                "Not available"
              }}
            </td>
          </tr>
          <tr class="bg-white">
            <td class="p-4">Data</td>
            <td>
              {{ capitalizeFirst(country.tariff?.rateData) || "Not available" }}
            </td>
            <td>Not available</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
// Helper function to capitalize only first letter
const capitalizeFirst = (str: string | undefined) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

interface Tariff {
  zoneId: number;
  rateData: string;
  rateSendSMS: string;
  rateReceiveSMS: string;
  rateSendMMSAu: string;
  rateReceiveMMSAu: string;
  rateSendMMSNonAu: string;
  rateReceiveMMSNonAU: string;
  rateMakeCalls: string;
  rateReceiveCalls: string;
}

interface Country {
  id: number;
  zoneId: number;
  displayName: string;
  popular: boolean;
  tariff?: Tariff;
}

defineProps<{
  country: Country;
}>();
</script>

<style scoped>
.roaming-rates-country {
  background-color: white;
}

th,
td {
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
}

td {
  @apply p-4 text-primary;
}
</style>
